export default function NotExistPage(){
    // create a good 404 page 
    return (
        <div style={{ 
            width: "100%", 
            height: "100vh", 
            display: "flex", 
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
            
        }}>
            <div style={{fontSize: 64, fontWeight: "bold"}}>
                404
            </div>
            <div style={{}}>page not found</div>
        </div>
    )
}